<template>
    <div>
        <el-drawer
            :visible.sync="showModal" 
            size="50%"
        >   
            <template slot="title">
                <div class="d-flex items-center justify-content-between mr-3">
                    <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <el-tag type="warning" class="rounded-circle" effect="dark">
                            <i class="el-icon-date"></i>
                        </el-tag>
                        <h5 class="font-weight-semibold mb-0">Evento / </h5>
                        <h6 class="mb-0">{{ mutatorDate }}</h6>
                    </div>

                    <el-tag v-if="event && event.status" :type="getTagTypeByStatus">{{ event.status }}</el-tag>
                </div>
            </template>

            <div class="px-3 pb-3">
                <el-tabs type="border-card" v-model="activeName">
                    <el-tab-pane name="first">
                        <span slot="label">
                            <i class="el-icon-tickets"></i>
                            <span class="ml-1">Detalhes</span>
                        </span> 
                        
                        <div class="d-flex flex-column" :style="{ gap: '12px'}">
                            <el-form    
                                v-if="!canBeEdited && event && event.status != 'REPROVADO'"
                                :model="payload" 
                                ref="eventEditForm" 
                                label-position="top" 
                                status-icon 
                                :rules="rules"
                            > 
                                <el-row :gutter="12">
                                    <!-- Titulo -->
                                    <el-col>
                                        <el-form-item prop="titulo">
                                            <label>Titulo</label>
                                            <el-input
                                                v-model="payload.titulo" 
                                                placeholder="Titulo do evento"
                                                :disabled="!shouldBeEdit || closedApprovedEventEdit"
                                            />
                                        </el-form-item>
                                    </el-col>
                                    
                                    <!-- Despesas -->
                                    <el-col>
                                        <el-form-item prop="email">
                                            <label>Despesas</label>
                                            <el-checkbox-group 
                                                v-model="payload.despesas" 
                                                size="small"
                                                :disabled="!shouldBeEdit || closedApprovedEventEdit"
                                            >
                                                <el-checkbox-button 
                                                    v-for="expense in expenses" 
                                                    :label="expense.value" 
                                                    :disabled="expense.value === 'ALMOCO'" 
                                                    :key="expense.value"
                                                >
                                                    {{ expense.text }}
                                                </el-checkbox-button>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-col>
            
                                    <!-- Itens das despezas -->
                                    <el-col v-if="handleItemsExpenses" class="mb-3">
                                        <div class="bg-light border rounded-lg p-2 d-flex align-items-center justify-content-between" :style="{ gap: '12px' }">
                                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                                <i class="el-icon-files"></i>
                                                <h6 class="mb-0 font-weight-bold">Itens da despezas</h6>
                                            </div>

                                            <el-button
                                                v-if="shouldBeEdit && !closedApprovedEventEdit"
                                                size="small"
                                                @click.native.prevent="addItemForExpense()"
                                            >
                                                <i class="el-icon-plus"></i>
                                                Novo item
                                            </el-button>
                                        </div>

                                        <div v-if="payload.itens_despesa.length > 0" class="p-3 rounded mt-2" :style="{ border: '1px dashed #dedede', borderSpacing: '4px' }">
                                            <template
                                                v-for="(item_despesa, index) in payload.itens_despesa"
                                            >
                                                <div
                                                    v-if="!item_despesa.deleted"
                                                    :key="item_despesa.id"
                                                    class="d-flex align-items-end" :style="{ gap: '12px', paddingInline: '20px', marginBottom: '12px' }"
                                                >
                                                    <!-- <el-tag type="primary" size="small" class="rounded-circle mb-1">{{ index + 1 }}</el-tag> -->
                                                    <el-form-item
                                                        :prop="`itens_despesa.${index}.tipo`"
                                                        class="mb-0"
                                                        :rules="[{ required: true, message: 'O tipo da despesa é obrigátorio', trigger: 'change' }]"
                                                    >
                                                        <label>Tipo</label>
                                                        <el-radio-group
                                                            v-model="payload.itens_despesa[index].tipo"
                                                            size="small"
                                                            :disabled="!shouldBeEdit || closedApprovedEventEdit"
                                                        >
                                                            <el-radio-button
                                                                v-for="item_des_tipo in [
                                                                    { value: 'PEDAGIO', text: 'Pedágio'},
                                                                    { value: 'ESTACIONAMENTO', text: 'Estacionamento'},
                                                                    { value: 'UBER', text: 'Uber'}
                                                                ]"
                                                                :label="item_des_tipo.value"
                                                                :key="item_des_tipo.value"
                                                            >
                                                                {{ item_des_tipo.text }}
                                                            </el-radio-button>
                                                        </el-radio-group>
                                                    </el-form-item>

                                                    <el-form-item
                                                        :prop="`itens_despesa.${index}.valor`"
                                                        class="mb-0"
                                                        :rules="[{ required: true, message: 'O valor da despesa é obrigátorio', trigger: 'blur' }]"
                                                    >
                                                        <label>Valor</label>
                                                        <el-input
                                                            v-model="payload.itens_despesa[index].valor"
                                                            size="small"
                                                            placeholder="0,00"
                                                            maxlength="250"
                                                            suffix-icon="el-icon-money"
                                                            v-mask="['#,##', '##,##', '###,##']"
                                                            :maxlength="6"
                                                            :disabled="!shouldBeEdit || closedApprovedEventEdit"
                                                        >
                                                            <template slot="prepend">R$</template>
                                                        </el-input>
                                                    </el-form-item>

                                                    <el-button
                                                        v-if="shouldBeEdit && !closedApprovedEventEdit"
                                                        size="small"
                                                        plain
                                                        type="danger"
                                                        circle
                                                        @click.native.prevent="handleRemoveItemExpense(item_despesa.id)"
                                                    >
                                                        <i class="el-icon-delete"></i>
                                                    </el-button>
                                                </div>
                                            </template>
                                        </div>
                                    </el-col>
    
                                    <!-- Observacoes -->
                                    <el-col :span="isAuthorized ? 12 : 24">
                                        <el-form-item prop="obs">
                                            <label>Observações</label>
                                            <el-input
                                                type="textarea"
                                                v-model="payload.obs" 
                                                placeholder="Observações sobre o evento"
                                                maxlength="250"
                                                show-word-limit
                                                :rows="5"
                                                :disabled="!shouldBeEdit || closedApprovedEventEdit"
                                            />
                                        </el-form-item>
                                    </el-col>
            
                                    <!-- Observacoes coord -->
                                    <el-col v-if="isAuthorized" :span="12">
                                        <el-form-item prop="obs_coordenacao">
                                            <label>Observações Coordenação</label>
                                            <el-input
                                                type="textarea"
                                                v-model="payload.obs_coordenacao" 
                                                placeholder="Observações da coordenação sobre o evento"
                                                maxlength="250"
                                                show-word-limit
                                                :rows="5"
                                            />
                                        </el-form-item>
                                    </el-col>

                                    <!-- Motivo -->
                                    <el-col v-if="!closedApprovedEventEdit && this.payload.editar_evento">
                                        <el-form-item 
                                            prop="motivo_edicao"
                                            :rules="[
                                                { required: true, message: 'O motivo para edição é obrigátorio', trigger: 'blur' },
                                                { validator: validateMin(10), trigger: 'change' }
                                            ]"
                                        >
                                            <label>Justificativa para edição</label>
                                            <el-input
                                                type="textarea"
                                                v-model="payload.motivo_edicao" 
                                                placeholder="Motivo para a edição do evento"
                                                maxlength="250"
                                                show-word-limit
                                                :rows="5"
                                                :disabled="isLoading"
                                            />
                                        </el-form-item>
                                    </el-col>
                                    
                                    <el-col v-if="shouldBeEdit && event && (event.status == 'APROVADO' || event.status == 'REPROVADO')">
                                        <div v-if="closedApprovedEventEdit" class="alert alert-success" role="alert">
                                            <div>
                                                <p class="mb-0"><b>Evento aprovado. Caso deseje edita-lo, clique no botão (editar) logo abaixo.</b></p>
                                            </div>
                                        </div>

                                        <div v-if="event.analisado_por" class="d-flex align-items-center mb-3" :style="{ gap: '12px' }">
                                            <span :style="{ fontSize: '12px' }"><b>Analisado por: </b></span>
                                            <div v-if="event.analisado_por" class="d-flex align-items-center" :style="{ gap: '8px' }">
                                                <el-avatar size="small">{{ event.analisado_por.name.charAt(0) }}</el-avatar>
                                                <div class="d-flex align-items-center">
                                                    <span :style="{ fontSize: '12px' }">
                                                        <b>{{ event.analisado_por.name }}</b>
                                                        em {{ formatDate(event.updated_at) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </el-col>

                                    <!-- Actions -->
                                    <el-col>
                                        <div class="d-flex align-items-center justify-space-between">
                                            <div>
                                                <el-button 
                                                    v-if="validateApprove"
                                                    type="info" 
                                                    plain 
                                                    size="small"
                                                    @click.native.prevent="handleDisapproveEvent()"
                                                >
                                                    <i class="el-icon-close"></i>
                                                    Reprovar
                                                </el-button>
    
                                                <el-button 
                                                    v-if="validateApprove"
                                                    type="success" 
                                                    plain 
                                                    size="small"
                                                    @click.native.prevent="handleApproveEvent()"
                                                >
                                                    <i class="el-icon-check"></i>
                                                    Aprovar
                                                </el-button>
    
                                                <el-button
                                                    v-if="event && event.status == 'APROVADO' && isAuthorized"
                                                    type="warning"
                                                    plain
                                                    size="small"
                                                    @click.native.prevent="handleRevokeApprovedEvent()"
                                                >
                                                    <i class="el-icon-refresh-left"></i>
                                                    Revogar aprovação
                                                </el-button>

                                                <el-button
                                                    v-if="shouldBeEdit && event && event.status == 'APROVADO' && !dateIsBeforeToday && !this.payload.editar_evento"
                                                    type="warning"
                                                    plain
                                                    size="small"
                                                    @click.native.prevent="handleEditEvent()" 
                                                >
                                                    <i class="el-icon-edit-outline"></i>
                                                    Editar
                                                </el-button>

                                                <el-button
                                                    v-if="this.payload.editar_evento"
                                                    type="info"
                                                    plain
                                                    size="small"
                                                    @click.native.prevent="handleEditEvent()" 
                                                >
                                                    Cancelar edição
                                                </el-button>
                                                
                                            </div>
    
                                            <div class="d-flex align-items-center justify-content-end flex-grow-1">
                                                <div>
                                                    <el-button 
                                                        plain
                                                        :disabled="isLoading"
                                                        @click="() => {
                                                            toggleModal();
                                                            resetForm();
                                                        }"
                                                    >
                                                        Cancelar
                                                    </el-button>
                
                                                    <el-button 
                                                        type="danger"
                                                        plain
                                                        :disabled="isLoading"
                                                        @click.native.prevent="handleDestroyEvent()"
                                                    >
                                                        <i v-if="isLoading" class="el-icon-loading"></i>
                                                        <i class="el-icon-delete"></i>
                                                        Excluir
                                                    </el-button>
                
                                                    <el-button 
                                                        v-if="this.payload.editar_evento"
                                                        type="primary"
                                                        plain
                                                        :disabled="isLoading"
                                                        @click="handleEditSubmit"
                                                    >
                                                        <i v-if="isLoading" class="el-icon-loading"></i>
                                                        <i class="fas fa-check-circle"></i>
                                                        Salvar
                                                    </el-button>

                                                    <el-button 
                                                        v-if="!this.payload.editar_evento && event && event.status != 'APROVADO'"
                                                        type="primary"
                                                        plain
                                                        :disabled="isLoading"
                                                        @click="onSubmit"
                                                    >
                                                        <i v-if="isLoading" class="el-icon-loading"></i>
                                                        <i class="fas fa-check-circle"></i>
                                                        Salvar
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>
    
                            <div v-else>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <h6 v-if="event" class="mb-0 font-weight-bold">
                                            {{ event.titulo }}
                                        </h6>
                                    </el-col>
                                    <el-col :span="12">
                                        <div v-if="event && event.cumpriu == null && event.status != 'REPROVADO'" class="d-flex justify-content-end">
                                            <el-button
                                                type="danger" 
                                                plain 
                                                size="small"
                                                @click.native.prevent="handleDenyEvent()"
                                            >
                                                <i class="el-icon-close"></i>
                                                Não cumpriu
                                            </el-button>
        
                                            <el-button 
                                                type="success" 
                                                plain 
                                                size="small"
                                                @click.native.prevent="handleConfirmEvent()"
                                            >
                                                <i class="el-icon-check"></i>
                                                Cumpriu
                                            </el-button>
                                        </div>
                                    </el-col>
                                </el-row>
    
                                <!-- Cumpriu -->
                                <div v-if="event && event.cumpriu" class="rounded border p-3 mt-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center" :style="{ gap: '8px'}">
                                            <i class="el-icon-check"></i>
                                            Realizado?
                                        </div>
    
                                        <el-tag 
                                            v-if="event" 
                                            :type="event.cumpriu == 'SIM' 
                                                ? 'success' 
                                                : 'danger'
                                            "
                                            size="small"
                                        >{{ event.cumpriu }}</el-tag>
                                    </div>
    
                                    <p v-if="event.justificativa" class="mt-3"><strong>Motivo:</strong> {{ event.justificativa }}</p>
                                </div>
    
                                <el-divider></el-divider>

                                <div v-if="event && event.status == 'REPROVADO'" class="alert alert-secondary" role="alert">
                                    <div>
                                        <p class="mb-0"><b>Este evento foi reprovado.</b></p>
                                    </div>
                                </div>
    
                                <div class="d-flex flex-column" :style="{ gap: '12px' }">
                                    <!-- Tipos despesas -->
                                    <el-descriptions title="Despesas" :column="4" size="small" :border="true">
                                        <el-descriptions-item 
                                            v-for="(expense) in expenses" 
                                            :span="4" 
                                            :label="expense.text"
                                            :key="expense.value"
                                        >
                                            <el-tag 
                                                v-if="event && event.tipos_despesas.includes(expense.value)" 
                                                type="success"
                                                class="rounded-pill"
                                                size="small"
                                            >
                                                Sim
                                            </el-tag>
                                            <el-tag 
                                                v-else 
                                                type="danger" 
                                                class="rounded-pill"
                                                size="small"
                                            >Não</el-tag>
                                        </el-descriptions-item>
                                    </el-descriptions>
        
                                    <!-- Items -->
                                    <div v-if="event && event.despesas.length > 0":style="{ gap: '12px' }">
                                        <div class="d-flex align-items-center mb-3" :style="{ gap: '8px' }">
                                            <i class="el-icon-files"></i>
                                            <h6 class="mb-0 font-weight-bold">Itens da despezas</h6>
                                        </div>
        
                                        <el-table
                                            class="rounded"
                                            :data="event.despesas" 
                                            align="center" 
                                            border
                                            row-key="id"
                                            size="mini"
                                        >  
                                            <!-- Tipo -->
                                            <el-table-column 
                                                label="Tipo" 
                                                prop="tipo" 
                                                align="left"
                                            >
                                                <div slot-scope="scope">{{ scope.row.tipo }}</div>
                                            </el-table-column>
        
                                            <!-- Valor -->
                                            <el-table-column 
                                                label="Valor" 
                                                prop="valor" 
                                                align="left"
                                            >
                                                <div slot-scope="scope">R$ {{ scope.row.valor }}</div>
                                            </el-table-column>
                                        </el-table>
                                    </div>
        
                                    <!-- OBS -->
                                    <el-row :gutter="20">
                                    <el-col :span="12">
                                        <div class="rounded border p-3">
                                            <div class="d-flex align-items-center mb-3" :style="{ gap: '8px'}">
                                                <i class="el-icon-warning-outline"></i>
                                                Observações
                                            </div>
            
                                            <p v-if="event && event.obs">{{ event.obs }}</p>
                                            <el-empty v-else description="Nenhuma observação"></el-empty>
                                        </div>
                                    </el-col>

                                    <el-col :span="12">
                                        <div class="rounded border p-3">
                                            <div class="d-flex align-items-center mb-3" :style="{ gap: '8px'}">
                                                <i class="el-icon-warning-outline"></i>
                                                Observações da coordenação
                                            </div>
            
                                            <p v-if="event && event.obs_coordenacao">{{ event.obs_coordenacao }}</p>
                                            <el-empty v-else description="Nenhuma observação"></el-empty>
                                        </div>
                                    </el-col>
                                    </el-row>
    
                                </div>

                                <div v-if="event && event.analisado_por" class="d-flex align-items-center mt-3" :style="{ gap: '12px' }">
                                    <span :style="{ fontSize: '12px' }"><b>Analisado por: </b></span>
                                    <div v-if="event.analisado_por" class="d-flex align-items-center" :style="{ gap: '8px' }">
                                        <el-avatar size="small">{{ event.analisado_por.name.charAt(0) }}</el-avatar>
                                        <div class="d-flex align-items-center">
                                            <span :style="{ fontSize: '12px' }">
                                                <b>{{ event.analisado_por.name }}</b>
                                                em {{ formatDate(event.updated_at) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane name="second">
                        <span slot="label">
                            <i class="el-icon-timer"></i>
                            <span class="ml-1">Histórico</span>
                        </span>

                        <el-timeline v-if="event && event.historico.length > 0">
                            <el-timeline-item 
                                v-for="(historic, index) in event.historico"
                                :timestamp="formatDate(historic.created_at, true)" 
                                placement="top"
                                :key="historic.id"
                                color="#0bbd87"
                            >
                                <el-card>
                                    <h6><b>{{ historic.status }}</b></h6>
                                    <h6 v-if="historic.obs">{{ historic.obs }}</h6>
                                    <div v-if="historic.user" class="d-flex align-items-center" :style="{ gap: '8px' }">
                                        <el-avatar size="small">{{ historic.user.name.charAt(0) }}</el-avatar>
                                        <div class="d-flex flex-column">
                                            <span class="font-weight-bold" :style="{ fontSize: '14px', marginBottom: '-4px' }">{{ historic.user.name }}</span>
                                            <span class="text-muted" :style="{ fontSize: '14px' }">{{ historic.user.email }}</span>
                                        </div>
                                    </div>
                                </el-card>
                            </el-timeline-item>
                        </el-timeline>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-drawer>

        <!-- Event Deny Reason -->
        <EventDenyReason ref="eventDenyReason" @dispatch="handleDispatch"/>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Form, 
        FormItem,
        CheckboxGroup,
        CheckboxButton,
        RadioGroup,
        RadioButton,
        Tag,
        Drawer,
        Tabs,
        TabPane,
        Timeline,
        TimelineItem,
        Card,
        Descriptions,
        DescriptionsItem,
        Divider,
        Empty,
        Table,
        TableColumn,
        Avatar
    } from "element-ui";

    import EventDenyReason from "./EventDenyReason.vue";

    // Utis
    import { formatDate, formattedDiffDate } from "@/util/formatters";
    import { validateMin } from "@/schemas/generalSchema";

    //Api
    import { AgendaApi } from "@/api/AgendaApi";

    const agendaApi = new AgendaApi();

    export default {
        data() {
            return {
                eventId: null,
                activeName: 'first',
                canBeEdited: false,
                payload: {
                    titulo: "",
                    obs: "",
                    despesas: [],
                    itens_despesa: [],
                    obs_coordenacao: "",
                    data: null,
                    editar_evento: false,
                    motivo_edicao: null,
                },
                event: null,
                showModal: false,
                isLoading: false,
                rules: {
                    data: [
                        { required: true, message: 'A data é obrigatória' }
                    ],
                    titulo: [
                        { required: true, message: 'O Titulo é obrigatório' },
                    ],
                },
                expenses: [
                    { value: 'VIAGEM', text: 'Viagem' },
                    { value: 'HOSPEDAGEM', text: 'Hospedagem' },
                    { value: 'ALMOCO', text: 'Almoço' },
                    { value: 'JANTAR', text: 'Jantar' },
                ],
                closedApprovedEventEdit: false,
            }
        }, 
        methods: {
            onSubmit() {
                this.$refs.eventEditForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;
                    
                    try {
                        await agendaApi.update(this.payload, this.eventId)

                        Notification.success({
                            title: 'Sucesso',
                            message: 'O evento foi atualizado!'
                        });

                    } catch (error) {
                        if (error?.response.status == 422) {
                            if (error?.response?.data.errors) {
                                error.response.event.errors.forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }
                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível atualizar o evento!'
                        });
                    } finally {
                        this.isLoading = false;
                        this.$emit('dispatch')
                    }
                })
            },
            handleEditSubmit() {
                this.$confirm('Deseja confirmar a edição desse evento? Se confirmado o evento deve ser aprovado novamente!', 'Confirmar edição', {
                    confirmButtonText: 'Confimar',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                   await this.onSubmit(); 

                    this.payload.editar_evento = false;

                    this.$refs.eventEditForm.validate( async (valid) => {
                        if (!valid) {
                            return false
                        } 
                        
                        await this.getEvent();
                    });
                }).finally(() => {
                    this.$emit('dispatch');
                })
            },
            async getEvent() {
                try {
                    this.isLoading = true;

                    const res = await agendaApi.show(this.eventId);

                    this.event = res;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o evento. Algo inesperado ocorreu!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async destroyEvent(eventId) {
                try {
                    const res = await agendaApi.destroy(eventId);

                    Notification.success({
                        title: 'Sucesso',
                        message: res.message
                    });
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o evento. Algo inesperado ocorreu!'
                    });
                }
            },
            /** Confirmar cumprimento do evento */
            async confirmEvent() {
                try {
                    await agendaApi.update({
                        cumpriu: 'SIM',
                        status: 'CUMPRIDO',
                    }, this.event.id);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Evento realizado!',
                        position: 'top-left'
                    });

                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível realizar o evento!',
                        position: 'top-left'
                    });
                } 
            },
            /** Aprovação do evento */
            async aproveEvent() {
                try {
                    await agendaApi.update({
                        analisado_por: this.getUserId.toString(),
                        status: 'APROVADO',
                    }, this.event.id);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Evento aprovado!',
                        position: 'top-left'
                    });

                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível aprovar o evento!',
                        position: 'top-left'
                    });
                } 
            },
            /** Desaprovação do evento */
            async disaproveEvent() {
                try {
                    await agendaApi.update({
                        analisado_por: this.getUserId.toString(),
                        status: 'REPROVADO',
                    }, this.event.id);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Evento reprovado!',
                        position: 'top-left'
                    });

                } catch (error) {
                    console.log(error);

                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível reprovar o evento!',
                        position: 'top-left'
                    });
                } 
            },
            async revokeApprovedEvent() {
                try {
                    await agendaApi.update({
                        analisado_por: this.getUserId.toString(),
                        status: 'PENDENTE',
                    }, this.event.id);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Evento revogado!',
                        position: 'top-left'
                    });

                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível revogar o evento!',
                        position: 'top-left'
                    });
                } 
            },
            handleDestroyEvent() {
                this.$confirm('Deseja realmente excluir este evento?', 'Excluir', {
                    confirmButtonText: 'Excluir',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    this.loading = true

                    await this.destroyEvent(this.event.id);

                    this.toggleModal();
                }).finally(() => {
                    this.loading = false;
                    this.$emit('dispatch');
                })
            },  
            handleConfirmEvent() { 
                this.$confirm('Deseja confirmar que este evento foi realizado?', 'Confirmação do evento', {
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    await this.confirmEvent();

                    await this.getEvent(); 

                }).finally(() => {
                    this.$emit('dispatch');
                })
            },
            handleDenyEvent() {
                this.$refs.eventDenyReason.toggleModal();
                this.$refs.eventDenyReason.eventId = this.eventId;
            },
            handleApproveEvent() {
                this.$confirm('Deseja aprovar este evento?', 'Aprovação do evento', {
                    confirmButtonText: 'Aprovar evento',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    await this.aproveEvent();

                    await this.getEvent(); 

                }).finally(() => {
                    this.$emit('dispatch');
                })
            },
            handleDisapproveEvent() {
                this.$confirm('Deseja confirmar a reprovação deste evento?', 'Reprovação do evento', {
                    confirmButtonText: 'Reprovar evento',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    await this.disaproveEvent();

                    await this.getEvent(); 

                }).finally(() => {
                    this.$emit('dispatch');
                })
            },
            handleRevokeApprovedEvent() {
                this.$confirm('Deseja confirmar a revogação deste evento?', 'Revogação do evento', {
                    confirmButtonText: 'Revogar evento',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    await this.revokeApprovedEvent();

                    await this.getEvent(); 

                }).finally(() => {
                    this.$emit('dispatch');
                })
            },
            async handleEditEvent() {
                this.payload.editar_evento = !this.payload.editar_evento;
                this.closedApprovedEventEdit = !this.closedApprovedEventEdit;

                if(this.payload.editar_evento == false) {
                    await this.getEvent();
                }
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.eventEditForm) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.eventEditForm.resetFields();
            },
            addItemForExpense() {
                this.payload.itens_despesa.push({
                    id: Date.now() + Math.floor(Math.random() * 1000),
                    tipo: "",
                    valor: "",
                    deleted: false,
                    new: true,
                })
            },
            handleRemoveItemExpense(id) {
                const item = this.payload.itens_despesa.find(
                    item => item.id === id
                );

                if (item) {
                    // Usa $set pois "deleted" pode não existir ainda no objeto
                    // (itens vindos do backend não têm essa chave) e o Vue 2
                    // não detecta a adição de uma propriedade nova a um objeto
                    // reativo, então a atribuição direta não atualiza a tela.
                    this.$set(item, 'deleted', true);
                }
            },
            handleDispatch() {
                this.$emit('dispatch');
                this.getEvent();
            },
            formatCurrencyToApi(value) {
                if (!value) {
                    return null
                }

                return value
                    .replace(/\./g, '')
                    .replace(',', '.')
            },
            formattedDiffDate,
            formatDate,
            validateMin
        },
        computed: {
            getUserId() {
                return this.$store.getters['user/getUserId']
            },  
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                ]);
            },
            mutatorDate() {
                return this.formattedDiffDate(this.payload.data);
            },
            handleItemsExpenses() {
                return this.payload.despesas.includes("VIAGEM")
            },
            getTagTypeByStatus() {
                if(this.event != null) {
                    switch(this.event.status) {
                        case 'APROVADO':
                            return 'success'
                        case 'PENDENTE':
                            return 'warning'
                        case 'CUMPRIDO':
                            return ''
                        case 'NAO CUMPRIU':
                            return 'danger'
                        case 'REPROVADO':
                            return 'info'
                        default: 
                            return 'info'
                    }
                }

                return null
            },
            validateApprove() {
                if(this.event == null) return;

                let shouldBeApprove = false;
                
                if (
                    this.event &&
                    this.event.id &&
                    this.event.cumpriu !== "NAO" &&
                    this.event.status !== "APROVADO" &&
                    this.event.status !== "REPROVADO"
                ) {
                    if (this.$store.getters['user/isAnyRole'](["adm", "coord_comercial"])) {
                        shouldBeApprove = true;
                    } else if (
                        this.getUserId !== this.event.user_id 
                        && this.$store.getters['user/isAnyRole'](["diretor_nacional", "gerente_nacional", "gerente_regional"])
                    ) {
                        shouldBeApprove = true;
                    }
                }
                
                return shouldBeApprove;
            },
            shouldBeEdit() {
                return this.getUserId === this.event?.user_id 
            },
            dateIsBeforeToday() {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const clickedDate = new Date(this.event.data);
                clickedDate.setHours(0, 0, 0, 0);

               if (clickedDate < today) {
                    return true;
                }

                return false;
            },
        },
        watch: {
            "payload.itens_despesa"(_newValue) {
                this.payload.itens_despesa.map(item => ({
                    ...item,
                    valor: this.formatCurrencyToApi(item.valor)
                }));
            },
            "payload.editar_evento"(_newValue) {
                if (_newValue) {
                    this.$set(this.payload, 'status', 'PENDENTE');
                    return;
                }

                this.$delete(this.payload, 'status');
            },
            "event": {
                handler(_newValue) {
                    this.payload = {
                        ...this.payload,
                        titulo: _newValue.titulo,
                        obs: _newValue.obs,
                        despesas: _newValue.tipos_despesas,
                        // Normaliza os itens vindos do backend com "new: false"
                        // e "deleted: false" explícitos. Sem isso, o item chega
                        // sem essas chaves e o backend não consegue diferenciar
                        // "já existe" de "é novo" (cai sempre no create), além
                        // de "deleted" não ser reativo se for adicionado depois.
                        itens_despesa: (_newValue.despesas || []).map(item => ({
                            ...item,
                            new: false,
                            deleted: false,
                        })),
                        obs_coordenacao: _newValue.obs_coordenacao,
                        data: _newValue.data,
                    }

                    if (_newValue.status == 'APROVADO') {
                        this.closedApprovedEventEdit = true;
                    }
                }
            },
            "showModal"(_newValue) {
                if(_newValue == false) {
                    this.closedApprovedEventEdit = false;
                }
            }   
        },
        components: {
            EventDenyReason,
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [CheckboxGroup.name]: CheckboxGroup,
            [CheckboxButton.name]: CheckboxButton,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Tag.name]: Tag,
            [Drawer.name]: Drawer,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Timeline.name]: Timeline,
            [TimelineItem.name]: TimelineItem,
            [Card.name]: Card,
            [Descriptions.name]: Descriptions,
            [DescriptionsItem.name]: DescriptionsItem,
            [Divider.name]: Divider,
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Avatar.name]: Avatar,
        },
    }
</script>
<style>
/* Mantém o visual de "marcado" no checkbox-button quando desabilitado,
   assim como já ocorre nativamente no radio-button do Element UI */
.el-checkbox-button.is-checked.is-disabled .el-checkbox-button__inner {
    /* color: #fff; */
    background-color: #F2F6FC; /* mesma cor usada pelo radio-button no estado checked+disabled */
    border-color: #F2F6FC;
    box-shadow: -1px 0 0 0 #F2F6FC;
}

/* Corrige a borda esquerda do primeiro botão do grupo, igual o Element UI faz para o checked normal */
.el-checkbox-button.is-checked.is-disabled:first-child .el-checkbox-button__inner {
    border-left-color: #F2F6FC;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/agenda/EventShowModal.vue